import React from 'react';
import { config, PORTAL } from '../../../config';
import MenuIcon from '@material-ui/icons/Menu';
import { useHistory } from 'react-router-dom';
import '../homestyles.css';

const Navbar = () =>
{
	const history = useHistory();

	const handleDashboard = () =>
	{
		history.push('/dashboard');
	};

	return (
		<div className='flexRow alignCntr pdngXS navbar'>
			{/* <div className='flexAutoRow' onClick={() => handleDashboard()}>
				<MenuIcon className='whiteTxt' fontSize='large' />
			</div> */}
			<div className='flexAutoRow logoImgCntnr pdngHSM'>
				{ config.smalllogo !=='' ?
					<img alt='Logo'
						src={PORTAL=='WORLD'?'/images/konx-prod.png':'/images/konx.png'}
						onClick={() => handleDashboard()}
					/>
					:
					<Typography
						variant='h6'
						noWrap color='inherit'
					>
						{config.title}
					</Typography>
				}
			</div>
		</div>
	);
};

export default Navbar;